// import React, { useState, useEffect } from "react";



const YouTubeView = (props) => {

  // const [content , setContent] = useState(props.data.d.source);
  // const [h, setCodeLan] = useState(props.data.d.cell_layout)

//   const Copy_btn = () => {
//     // Copy to Clipbord Button
//     console.log("button Display clicked");
//     var input = document.createElement('input');
//     // var value  = this.state.open_topic.cells[index].source;
//     var value  = props.data.d.source;
//     input.setAttribute('value', value);
//     document.body.appendChild(input);
//     input.select();
//     var result = document.execCommand('copy');
//     document.body.removeChild(input);
//     return result;
// };

  return (
    <div className="youtube-view">
      <iframe 
          width="560" 
          height="315" 
          src={"https://www.youtube.com/embed/"+ props.data.d.source} 
          title="YouTube video player" 
          frameborder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowFullScreen
          ></iframe>
    </div>
    
  );
};

export default YouTubeView;